import ComponentHeader from '../ComponentHeader';

const LineBreak = (props) => {
	const { data, style } = props;
	let baseClasses = 'SortableItem rfb-item';
	if (data.pageBreakBefore) {
		baseClasses += ' alwaysbreak';
	}
	let fieldName = `${data.group_name}_${data.id}`;
	return (
		<div name={fieldName.toLowerCase()} style={{ ...style }} className={baseClasses}>
			<ComponentHeader {...props} />
			<hr />
		</div>
	);
};

export default LineBreak;
